/*
This file was created by the script build.py
*/

import _ from 'lodash';
import "/src/assets/styles/style.css"
import {clearAll} from "./globalFilterUI"
import {globalSearchObject} from "./searchObjects";

require("./collisionSystemUI")

require("./acceleratorParametersUI")

require("./physicsThemeUI")

require("./workingGroupUI")

require("./finalStatesUI")

require("./finalStatesSignatureUI")

require("./interpretationUI")

require("./smAnalysisCharacteristicsUI")

require("./furtherSearchCategorisationUI")

require("./furtherCategorisationHeavyIonUI")

export const isProd = process.env.NODE_ENV === 'development';
export var datatable;
export var publications2;

     //Data Table from jQuery
    $(document).ready(function() {

        $(".onloadLoader").remove()
        datatable = $('#publications').DataTable( {
            dom: '<"top"lpi>rt<"bottom"ip>',
            fixedHeader : true,
            orderCellsTop: true,
            "processing": true,
            "serverSide": true,
            "ajax":{
                "url": process.env.BACKEND_URL + "/publications",
                "headers":{
                    "Authorization": process.env.READ_TOKEN
                },
                "data": function ( d ) {
                    return $.extend( {globalSearchObject}, d, {
                      "extra_search": $('#extra').val()
                    } );
                  }
            },
            "oLanguage": {
                "sZeroRecords":
                function(){
                    return errorMessage()
                }
              },
            initComplete: function() {
                //$('#publications thead tr').clone(true).appendTo( '#publications thead' );
                $('#publications thead').append(
                `<tr>
                 <th>Code</th>
                 <th>Title</th>
                 <th>Status</th>
                </tr>`
                )
                $('#publications thead tr:eq(1) th').each( function (i) {
                    this.classList.remove("sorting", "sorting_desc")
                    this.classList.add("unsorting")
                    var title = $(this).text();
                    $(this).html( '<input id="searchEveryColumn'+i+'" width="48px" type="search" style="width: 100%" placeholder="Search '+title+'"/>' );
                    $( 'input', this ).on( 'keyup change', function () {
                        if ( datatable.column(i).search() !== this.value ) {
                            if(i == 1){
                                i = 4
                                datatable
                                    .column(i)
                                    .search( this.value )
                                    .draw();
                            }
                            else{
                                datatable
                                .column(i)
                                .search( this.value )
                                .draw();
                            }
                        }
                    } );
                } );
            },
            "autoWidth": false,
            "drawCallback": function ( settings ){
                MathJax.Hub.Config({
                    tex2jax: {inlineMath: [["$","$"],["\\(","\\)"]]}
            });
                MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
            },
            columns: [
                {
                    title: "Code",
                    "width": "200px",
                    "render": function( data, type, row) {
                        return addLinkToCode(row.code, row.pub_type)
                    },
                    "defaultContent": ""
                },
                {
                    title: "Title",
                    "width": "1000px",
                    "data": "latex_title",
                    "defaultContent": ""
                },
                {
                    title: "Status/Link",
                    "width": "300px",
                    "render": function( data, type, row) {
                        return linkFormatter(row.status,row.journal_link)
                    },
                    "defaultContent": ""
                },
                {
                    title: "Date",
                    "width": "100px",
                    "render": function( data, type, row){
                        const options = { year: 'numeric', month: 'long', day: 'numeric' };
                        const date = new Date(row.change_date)
                        return date.toLocaleDateString('en-US', options);
                    },
                    "defaultContent": "",
                },
                {
                    title: "Title",
                    "width": "1000px",
                    "data": "clean_title",
                    "defaultContent": "",
                    "visible": false
                },
                {
                    "data": "pub_type",
                    "visible": false
                }
            ],
            "order": [[3,"desc"]],
            createdRow: function( row,data,index ){
                $("td:nth-child(2)", row).attr("title", sizeKeywords(data.keywords));
            },

        } );

        clearAll("buttonClearAll")

})

 export function errorMessage(){
        const buttonPAS = document.getElementById("buttonGlobalPAS")
        if(buttonPAS.classList.contains("selected","text-light")){
            return "No CMS results to display"
        }
        else{

            return `
            <script>
             function clickPasButton(){
                document.getElementById("buttonGlobalPAS").click()
             }
            </script>
            <a id="errorMessageDataTable" class="removeUnderline clickableAwesomeFont" onclick="clickPasButton()">
            No results found for CMS publications - to also search the preliminary results click here.<a/>`
        }
    }

    function sizeKeywords(keywords){
        var result = [];
        for(var i = 0; i < keywords.length; i++){
            if(i < keywords.length-1){
                result = result + keywords[i] + ", ";
            }
            else{
                result = result + keywords[i]
            }
        }
        return  "keywords: "+result.toString()
    }

    function linkFormatter(status,link){
        if(link){
            return '<a class="removeUnderline" target="_blank" href="' + link + '">' + status + '</a>';
        }
        else{
            return status;
        }
    }

    function addLinkToCode(code,pubType){
        if(pubType == "PAS"){
            return '<a class="removeUnderline" target="_blank" href="http://cms-results.web.cern.ch/cms-results/public-results/preliminary-results/' + code +'/index.html">'+ code +'</a>'
        }
        else{
            return '<a class="removeUnderline" target="_blank" href="https://cms-results.web.cern.ch/cms-results/public-results/publications/' + code +'/index.html">'+ code +'</a>'
        }
    }


